import React from 'react';
import {AssetTypeFormProps} from '../interfaces';
import {
  ContainerNumberField,
  AssetSizeSelect,
  ChassisNumberField,
  ChassisLicensePlateField,
  SealNumberField,
  DriverFields,
  ScacCodeField,
  TruckLicensePlateField,
  NotesField,
} from '../fields';

/**
 * Check-in form for Loaded Container asset types.
 * Covers: CONTAINER_LOADED, TRUCK_CONTAINER_LOADED.
 *
 * Required fields: Container Number, Asset Size, Chassis Number, Seal Number,
 *                  Driver License Number, Driver First Name, Driver Last Name.
 */
const LoadedContainerForm: React.FC<AssetTypeFormProps> = ({form, errors, onValueChange, onAssetSizeChange}) => {
  return (
    <>
      <ContainerNumberField
        value={form.containerNumber}
        onValueChange={onValueChange}
        error={errors.containerNumber}
        required
      />
      <AssetSizeSelect
        value={form.assetSize}
        onChange={onAssetSizeChange}
        required
      />
      <ChassisNumberField
        value={form.chassisNumber}
        onValueChange={onValueChange}
        error={errors.chassisNumber}
        required
      />
      <ChassisLicensePlateField
        value={form.chassisLicensePlateNumber}
        onValueChange={onValueChange}
      />
      <SealNumberField
        value={form.sealNumber}
        onValueChange={onValueChange}
        error={errors.sealNumber}
        required
      />
      <DriverFields
        form={form}
        errors={errors}
        onValueChange={onValueChange}
        requireLicense
      />
      <ScacCodeField
        value={form.scacCode}
        onValueChange={onValueChange}
        error={errors.scacCode}
      />
      <TruckLicensePlateField
        value={form.truckLicensePlateNumber}
        onValueChange={onValueChange}
        error={errors.truckLicensePlateNumber}
      />
      <NotesField
        value={form.notes}
        onValueChange={onValueChange}
      />
    </>
  );
};

export default LoadedContainerForm;

